import * as React from "react";

const ReturnIcon: React.FC = () => {
    return (
        <svg width="12px" height="18px" viewBox="0 0 12 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>54159739-E7B6-46EE-8822-B2E55F5AA848</title>
            <g id="HD" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="01-Order-details-HD" transform="translate(-291.000000, -268.000000)" fill="#002554">
                    <g id="Group-142" transform="translate(291.000000, 257.000000)">
                        <g id="Group-141" transform="translate(0.000000, 7.000000)">
                            <g id="Group-140" transform="translate(0.000000, 3.000000)">
                                <g id="Actions-/-Operations-/-insert-/-24" transform="translate(0.000000, 1.000000)">
                                    <path d="M9.75,3.75 L3,3.75 L5.5575,1.0575 L4.5,0 L0,4.5 L4.5,9 L5.5575,7.9425 L3,5.25 L9.75,5.25 C10.1642136,5.25 10.5,5.58578644 10.5,6 L10.5,15 C10.5,15.4142136 10.1642136,15.75 9.75,15.75 L0.75,15.75 L0.75,17.25 L9.75,17.25 C10.9926407,17.25 12,16.2426407 12,15 L12,6 C12,4.75735931 10.9926407,3.75 9.75,3.75 Z" id="Fill"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}; 

export default React.memo(ReturnIcon);
